<template>
    <section>
        <transition-group name="modal">
            <div id="brand" class="modal-mask flexContainer" key="brand">
                <div id="commentlist">
                    <h2 class="uppercase txtCenter commentTitle">Comments ({{ getComments.length }})</h2>
                    <img src="../../assets/croix.png" width="20" height="20" alt="" @click="close" class="cross abs pointer" />
                    <div class="flexContainer fd-c">
                        <div v-for="n in getComments" class="commentaire">
                            <div class="flexContainer fd-r jc-sb">
                                <div class="userInfo">{{ n.createdUser.initial }}</div>
                                <div class="commentContent rel full">
                                    <p class="bold">{{ n.createdUser.firstname }} {{ n.createdUser.lastname }}</p>
                                    <p>{{ n.content }}</p>
                                    <p class="abs date">{{ n.createdAt }}</p>
                                </div>
                            </div>
                        </div>
                        <h3 class="uppercase txtCenter" v-if="getComments.length === 0">{{ $t("modalComment.noComment") }}</h3>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
import Vuex from "vuex";
import cacheService from "@/services/cache";

export default {
    data() {
        return {
            planoId: ""
        };
    },
    directives: {},
    props: {},
    methods: {
        close() {
            this.$emit("closeModal", false);
        }
    },
    computed: {
        ...Vuex.mapGetters({
            getComments: "plano/data/getComments"
        })
    },
    created() {
        this.planoId = cacheService.get("plano");
        this.$store.dispatch("plano/data/getComments", { id: this.planoId }).then(() => {});
    }
};
</script>

<style lang="scss" scoped>
.lineUnderComment {
    margin-top: 30px;
    border-top: 1px solid #f4f4f4;
    width: 60%;
}
.commentTitle {
    padding-top: 30px;
}
.commentaire {
    width: 80%;
    margin: 0 auto;
    padding: 30px 0;
    border-bottom: 1px solid #ddd;
}
.userInfo {
    height: 50px;
    width: 55px;
    border-radius: 50px;
    margin-right: 15px;
    text-align: center;
    line-height: 50px;
    border: 1px solid #dddddd;
}
.commentContent {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    height: 100px;
    background-color: #f4f4f4;
    p {
        font-family: Roboto;
        font-size: 14px;
    }
    .date {
        right: 15px;
        margin: 0;
    }
}
#commentlist {
    background-color: white;
    margin: auto;
    width: 800px;
    height: 500px;
    border-radius: 3px;
    overflow-y: auto;
}
._selectedCampaign,
._selectedZone {
    color: #0000f0;
    font-weight: bold;
}
/* height firefox modal */
._modalWrapper_ {
    height: 100%;
}
/* end height */
.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
    .cross {
        top: 23.3%;
        right: 28.6%;
        z-index: 2;
    }
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            margin: auto;
            .brandWrap {
                padding: 5px;
            }
            p {
                font-family: Roboto;
                font-size: 18px;
            }
            .swiper-container-horizontal {
                .swiper-pagination {
                    margin-top: 10px;
                    position: initial;
                }
            }
            .swiper-button-prev {
                left: 25%;
                height: 15px;
            }
            .swiper-button-next {
                right: 25%;
                height: 15px;
            }
        }
    }
}
#zone {
    .brandLogo {
        margin: auto;
        line-height: 110px;
    }
}
#campaign {
    .brandLogo {
        margin: auto;
        line-height: 110px;
    }
}
#related-item {
    .modalBody {
        h2 {
            margin-top: 0px;
        }
        #selectContainer {
            margin-bottom: 30px;
        }
        width: 650px;
        min-height: 200px;
        background: #fff;
        border-radius: 4px;
        padding: 30px;
        #filterCategory {
            margin-top: 30px;
            margin-bottom: 20px;
        }
    }
}
@media (max-width: 768px) {
    .modal-mask {
        #commentlist {
            width: 100%;
            height: 100%;
            border-radius: 0;
        }
        .cross {
            right: 20px;
            top: 20px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// modalComment.vue?85a6b38c